import api from "src/rest/api";
import { PM2LogResponse, PM2Process } from "../types/pm2";

export const pm2Service = {
  listProcesses: () => api.post<PM2Process[]>("/pm2/"),

  restartApp: (appName: string) => api.post("/pm2/restart", { appName }),

  stopApp: (appName: string) => api.post("/pm2/stop", { appName }),

  getLogs: (appName: string) =>
    api.post<PM2LogResponse>("/pm2/logs", { appName }),
};
